/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import Page from '../../lib/page';
import { getComplaintsPageInfo } from '../../lib/globalHelper';

/**
 * UK Complaints Page
 */
const BrexitComponent = (props) => {
  const {
    disputeLinkClick, complaintsLinkClick, renderCommonQuestions, renderContactChannels, renderSubmitComplaint,
  } = props;

  const complaintsTextInfo = getComplaintsPageInfo();

  return (
    <div className="brexit-complaints-page">
      <div className="brexit-complaints-page-div">
        <p className="brexit-complaints-page-div__intro-text">{complaintsTextInfo.introText}</p>
        <p className="brexit-complaints-page-div__dispute-text">
          {complaintsTextInfo.disputeText}
          <a href={Page.getResolutionURL()} onClick={() => disputeLinkClick()}> open a dispute.</a>
        </p>
        {renderCommonQuestions}
        {renderContactChannels}
        {renderSubmitComplaint}
        <h3 className="brexit-complaints-page-div__next-header">{complaintsTextInfo.nextLabel}</h3>
        <p className="brexit-complaints-page-div__response-text">{complaintsTextInfo.responseText}</p>
        <h3 className="brexit-complaints-page-div__after-response-header">{complaintsTextInfo.afterResponseLabel}</h3>
        <p className="brexit-complaints-page-div__after-response-text">
          {complaintsTextInfo.afterResponseTextUpdate}
          <b>{complaintsTextInfo.afterResponseTextUpdateBold}</b>
        </p>
        <p className="brexit-complaints-page-div__after-response-text">
          {complaintsTextInfo.fosMessage}
          <a
            href={complaintsTextInfo.fosUrl}
            onClick={() => complaintsLinkClick(complaintsTextInfo.fosUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {complaintsTextInfo.fosUrl}
          </a>
          {complaintsTextInfo.fosMessageEnd}
        </p>
        <p className="brexit-complaints-page-div__after-response-text">
          {complaintsTextInfo.cssfMessage}
          <a
            href={complaintsTextInfo.cssfUrl}
            onClick={() => complaintsLinkClick(complaintsTextInfo.cssfUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {complaintsTextInfo.cssfUrl}
          </a>
          {complaintsTextInfo.cssfComplaintMessage}
          <a
            href={complaintsTextInfo.cssfComplaintMessageUrl}
            onClick={() => complaintsLinkClick(complaintsTextInfo.cssfComplaintMessageUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {complaintsTextInfo.cssfComplaintMessageUrl}
          </a>
          {complaintsTextInfo.cssfComplaintMessageEnd}
        </p>
        <h3 className="brexit-complaints-page-div__complaints-data-header">{complaintsTextInfo.complaintsData}</h3>
        <p className="brexit-complaints-page-div__complaints-data-summary">
          {complaintsTextInfo.complaintsSummary}
          <a
            href={complaintsTextInfo.complaintsDataUrl}
            onClick={() => complaintsLinkClick(complaintsTextInfo.complaintsDataUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {complaintsTextInfo.complaintsDataLinkText}
          </a>
          {complaintsTextInfo.complaintsSummaryDuration}
        </p>
      </div>
    </div>
  );
};

BrexitComponent.propTypes = {
  disputeLinkClick: PropTypes.func.isRequired,
  complaintsLinkClick: PropTypes.func.isRequired,
  renderCommonQuestions: PropTypes.func.isRequired,
  renderContactChannels: PropTypes.func.isRequired,
  renderSubmitComplaint: PropTypes.func.isRequired,
};

export default BrexitComponent;
